export default __webpack_public_path__ + "static/macbook-a30bef62235c7d9b6d357ff30cb22ef2.png";